module.exports = __webpack_public_path__ + "static/img/home_flow.0b9df58.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home_flow.png
// module id = g9JQ
// module chunks = 2